import { createAsyncThunk } from '@reduxjs/toolkit';
import createNotification from '../../../../utils/createNotification';
import { EngagementMeetingProposalContract } from '../models/engagement-meeting-proposal-contract';

export const FetchEngagementMeetingProposals = createAsyncThunk(
    'engagementMeetings/fetchMeetingProposals',
    async (engagementId: number, dispatch: any) => {
        const axios = dispatch.getState().core.axios;

        try {
            const response = await axios.get(
                `/api/Marketplace/Engagements/${engagementId}/MeetingScheduling`
            );

            if (response.status !== 200) {
                createNotification(
                    'Could not fetch meeting proposals at the moment.',
                    'error'
                );
                throw new Error('Failed to fetch meeting proposals');
            }

            return response.data as EngagementMeetingProposalContract[];
        } catch (error) {
            createNotification(
                'An error occurred while fetching meeting proposals.',
                'error'
            );
            throw error;
        }
    }
);